<template>
  <div class="app-container">
    <!-- <el-tabs v-model="auditType" type="card">
      <el-tab-pane key="auditBeforePreempt" :label="$t('SalesOrderToBeApproved.Pending')" name="0" />
      <el-tab-pane key="auditBeforeDeliver" :label="$t('SalesOrderToBeApproved.reviewed')" name="1" />
    </el-tabs> -->
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :search-btn-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderToBeApproved.Order')" prop="orderNo">
            <el-tooltip class="item" effect="dark" :content="$t('SalesOrderToBeApproved.Tripartite')" placement="top">
              <BjInputCode v-model="queryParams.orderNo" :placeholder="$t('SalesOrderToBeApproved.Order')" comma @keyup.enter.native="handleQuery" />
            </el-tooltip>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderToBeApproved.Product')" prop="spuName">
            <BjInput
              v-model="queryParams.spuName"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col> -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderToBeApproved.SKU')" prop="skuCode">
            <BjInput v-model="queryParams.skuCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('SalesOrderToBeApproved.SKU')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderToBeApproved.source')" prop="actionType">
            <BjSelectLov v-model="queryParams.actionType" :option-list="ORDER_ACTION_TYPE_LIST" :placeholder="$t('SalesOrderToBeApproved.source')"/>
          </el-form-item>
        </el-col>
        <BjSelectChannelStore :span="colSpan" :query-params="queryParams" :query-props="['channel', 'storeIdList']" multiple />

        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderToBeApproved.nickname')" prop="buyerNick">
            <BjInput v-model="queryParams.buyerNick" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('SalesOrderToBeApproved.nickname')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderToBeApproved.name')" prop="receiverName">
            <BjInput v-model="queryParams.receiverName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('SalesOrderToBeApproved.name')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <BjFormItemMobile v-model="queryParams.mobile" prop="mobile" :label="$t('SalesOrderToBeApproved.mobile')" :placeholder="$t('SalesOrderToBeApproved.mobile')" clearable />
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderToBeApproved.Comments')" prop="buyerRemarks">
            <el-row>
              <el-col :span="8">
                <BjSelectLov v-model="queryParams.isBuyerRemarks" :option-list="STATUS_HAVE_TRUE" :placeholder="$t('SalesOrderToBeApproved.Comments')"/>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="15">
                <BjInput v-model="queryParams.buyerRemarks" :maxlength="MAX_LENGTH.DEFAULT" clearable :placeholder="$t('SalesOrderToBeApproved.Comments')"/>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderToBeApproved.Merchant')" prop="orderRemarks">
            <el-row>
              <el-col :span="8">
                <BjSelectLov v-model="queryParams.isOrderRemarks" :option-list="STATUS_HAVE_TRUE" :placeholder="$t('SalesOrderToBeApproved.Merchant')"/>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="15">
                <BjInput v-model="queryParams.orderRemarks" :maxlength="MAX_LENGTH.DEFAULT" clearable :placeholder="$t('SalesOrderToBeApproved.Merchant')"/>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderToBeApproved.have')" prop="isGift">
            <BjSelectLov v-model="queryParams.isGift" :option-list="STATUS_HAVE_TRUE" :placeholder="$t('SalesOrderToBeApproved.have')"/>
          </el-form-item>
        </el-col>
        <!--  -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderToBeApproved.placement')">
            <BjDateTimerangePicker v-model="queryParamsTime_order" :placeholder="$t('SalesOrderToBeApproved.placement')"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderToBeApproved.Payment')">
            <BjDateTimerangePicker v-model="queryParamsTime_pay" :placeholder="$t('SalesOrderToBeApproved.Payment')"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderToBeApproved.Internal')">
            <BjDateTimerangePicker v-model="queryParamsTime_create" :placeholder="$t('SalesOrderToBeApproved.Internal')"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderToBeApproved.code')" prop="address">
            <BjSelectLov v-model="queryParams.address" :option-list="addressList" :placeholder="$t('SalesOrderToBeApproved.code')"/>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:beforeSearchBtn>
        <el-col :span="24 - colSpan">
          <BjStatusTabs :value="auditTabsValue" :option-list="TOW_TABS[auditType]" @handleTabClick="handleTabClick" />
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button v-if="cptAuditPermission" type="primary" class="main-btn" @click="onAudit">{{ $t('SalesOrderToBeApproved.Approved') }}</el-button>
          <el-button v-if="cptAuditPermission" type="primary" @click="onNoAudit">{{ $t('SalesOrderToBeApproved.Approval') }}</el-button>
          <el-button type="primary" @click="deleteCache">{{ $t('SalesOrderToBeApproved.deleteCache') }}</el-button>
          <el-button type="primary" @click="onOrderRetrieval">{{ $t('SalesOrderToBeApproved.onOrderRetrieval') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'outerOrderNo'">
                <span class="link" @click="$toBusinessThirdOrderView(scope.row.outerOrderNo)">{{
                  scope.row[col.prop]
                }}</span>
                <BjCopyIcon :copy="scope.row[col.prop]" />
              </template>
              <template v-else-if="col.prop === 'innerOrderNo'">
                <span class="link" @click="$toBusinessOrderInternalView(scope.row.innerOrderNo)">{{
                  scope.row[col.prop]
                }}</span>
                <BjCopyIcon :copy="scope.row[col.prop]" />
              </template>

              <template v-else-if="col.prop === 'tags'">
                <BjTagList :tag-code-string="scope.row[col.prop]" size="mini" circle />
              </template>

              <template v-else-if="col.prop === 'goodsQuatity'">
                <span class="link" @click="onSkuDetail(scope.row)">{{ scope.row[col.prop] }}</span>
              </template>
              <template v-else-if="
                  col.prop === 'totalAmount' || col.prop === 'buyerPay' || col.prop === 'costPrice'
                ">
                {{ $number2money(scope.row[col.prop]) }}
              </template>

              <template v-else-if="col.prop === 'deliveryStatus'">
                <el-tag :type="scope.row[col.prop] === 2 ? 'success' : 'info'">{{
                  $t(ORDER_INTERNAL_DELIVER_STATUS_LIST.bjGet(scope.row[col.prop]))
                }}</el-tag>
              </template>

              <template v-else-if="col.prop === 'stockFlag'">
                {{ $t(STATUS_YES_NUM.bjGet(scope.row[col.prop])) }}
              </template>

              <template v-else-if="col.prop === 'isGift'">
                <el-tag :type="scope.row[col.prop] ? 'success' : 'info'">{{
                  $t(STATUS_HAVE_TRUE.bjGet(scope.row[col.prop]))
                }}</el-tag>
              </template>

              <template v-else-if="col.prop === 'actionType'">
                {{ $t(ORDER_ACTION_TYPE_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="col.prop === 'businessType'">
                {{ $t(ORDER_BUSINESS_TYPE_LIST.bjGet(scope.row[col.prop])) }}
              </template>

              <template v-else-if="col.prop === 'auditStatus'">
                {{ $t(ORDER_INTERNAL_AUDIT_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="col.prop === 'preemptionStatus'">
                {{ $t(ORDER_INTERNAL_PREEMPT_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="col.prop === 'sourceStatus'">
                {{ $t(ORDER_INTERNAL_SOURCE_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="col.prop === 'suspendStatus'">
                {{ $t(ORDER_INTERNAL_HAND_UP_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="col.prop === 'syncPreempStatus'">
                {{ $t(ORDER_INTERNAL_PREEMPT_BACK_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="col.prop === 'syncDeliveryStatus'">
                {{ $t(ORDER_INTERNAL_STOCK_BACK_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="Object.keys(ORDER_DECRYPT_NAME).includes(col.prop)">
                <BjDecrypt :row="scope.row" :row-key="col.prop" :channel="scope.row.channel" :type="ORDER_DECRYPT_NAME[col.prop]" :order-sn="scope.row.outerOrderNo" :copy="col.prop === 'receiverPhoneMask'" />
              </template>
              <!-- <template v-else-if="col.prop === 'auditStatus'">
                <el-tag :type="scope.row[col.prop] === 2 ? 'success' : 'info'">{{
                  $t(ORDER_INTERNAL_ORDER_STATUS_LIST.bjGet(scope.row[col.prop]))
                }}</el-tag>
              </template> -->

              <template v-else-if="col.prop === 'mobile'">
                {{ scope.row[col.prop] | phoneFilter }}
              </template>
              <template v-else-if="col.prop === 'creationDate'">
                <span>{{ scope.row[col.prop] | timeOperateTwoHour }}</span>
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <!-- <el-button v-if="!props.row.releaseStatus" type="text" class="delete-btn" @click="onDelete(props.row)">{{ $t('delText') }}</el-button> -->
              <el-button :disabled="props.row.suspendStatus!='31201'" type="text" class="delete-btn" @click="onHangUp(props.row)">{{ $t('InternalSalesOrderDetails.Unhook') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 弹窗 -->
    <el-dialog :title="goodsInfoTab.title" :visible.sync="goodsInfoTab.visible" width="80%">
      <GoodsInfoTab :order-id="goodsInfoTab.orderId" :business-type="ORDER_BUSINESS_TYPES.COMMON" />
    </el-dialog>
    <formDialog ref="failReason" @comfirm="getFailReason" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { settingApi, orderApi } from '@/api';
import GoodsInfoTab from './components/GoodsInfoTab';
import {
  ORDER_INTERNAL_AUDIT_STATUS_LIST,
  ORDER_TRADE_TYPE_LIST,
  ORDER_BUSINESS_TYPE_LIST,
  ORDER_ACTION_TYPE_LIST,
  STATUS_YES_NUM,
  STATUS_HAVE_TRUE,
  ORDER_INTERNAL_ORDER_STATUS_LIST,
  ORDER_INTERNAL_PREEMPT_STATUS_LIST,
  ORDER_INTERNAL_PREEMPT_BACK_STATUS_LIST,
  ORDER_INTERNAL_SOURCE_STATUS_LIST,
  ORDER_INTERNAL_DELIVER_STATUS_LIST,
  ORDER_INTERNAL_STOCK_BACK_STATUS_LIST,
  ORDER_INTERNAL_HAND_UP_STATUS_LIST,
  ORDER_INTERNAL_ORDER_AUDIT_TABS_BEFORE_SOURCE,
  ORDER_INTERNAL_ORDER_AUDIT_TABS_BEFORE_PREEMPT,
  ORDER_INTERNAL_ORDER_AUDIT_PERMISSION_RULES,
  ORDER_BUSINESS_TYPES,
  ORDER_DECRYPT_NAME,
} from '@/utils/constants';
import formDialog from './components/formDialog.vue';

const getDefaultForm = () => {
  return {};
};
// import tableData from './data.json';
export default {
  name: 'BusinessOrderAudit',
  components: { GoodsInfoTab, formDialog },
  mixins: [pageMiXin],
  data() {
    return {
      ORDER_INTERNAL_AUDIT_STATUS_LIST,
      ORDER_TRADE_TYPE_LIST,
      ORDER_BUSINESS_TYPE_LIST,
      ORDER_ACTION_TYPE_LIST,
      STATUS_YES_NUM,
      STATUS_HAVE_TRUE,
      ORDER_INTERNAL_ORDER_STATUS_LIST,
      ORDER_INTERNAL_PREEMPT_STATUS_LIST,
      ORDER_INTERNAL_PREEMPT_BACK_STATUS_LIST,
      ORDER_INTERNAL_SOURCE_STATUS_LIST,
      ORDER_INTERNAL_DELIVER_STATUS_LIST,
      ORDER_INTERNAL_STOCK_BACK_STATUS_LIST,
      ORDER_INTERNAL_HAND_UP_STATUS_LIST,
      ORDER_INTERNAL_ORDER_AUDIT_TABS_BEFORE_SOURCE,
      ORDER_INTERNAL_ORDER_AUDIT_TABS_BEFORE_PREEMPT,
      ORDER_BUSINESS_TYPES,
      ORDER_DECRYPT_NAME,
      TOW_TABS: [
        ORDER_INTERNAL_ORDER_AUDIT_TABS_BEFORE_SOURCE,
        ORDER_INTERNAL_ORDER_AUDIT_TABS_BEFORE_PREEMPT,
      ],
      queryApi: orderApi.getOrderAuditPage,
      // 查询参数
      queryParamsTime_order: [],
      queryParamsTime_pay: [],
      queryParamsTime_create: [],
      addressList: [{label: 'AU', value: 'AU'}, {label: 'NZ', value: 'NZ'}],
      auditTabsValue: ORDER_INTERNAL_ORDER_AUDIT_TABS_BEFORE_SOURCE[0].value,
      queryParams: {
        businessType: ORDER_BUSINESS_TYPES.COMMON,
        auditType: 0,
        auditStatus: ORDER_INTERNAL_ORDER_AUDIT_TABS_BEFORE_SOURCE[0].value.split(','),
        //
        orderNo: null,
        spuName: null,
        skuCode: null,
        channel: null,
        storeIdList: [],
        actionType: null,
        buyerNick: null,
        receiverName: null,
        mobile: null,
        isBuyerRemarks: null,
        buyerRemarks: null,
        isOrderRemarks: null,
        orderRemarks: null,
        isGift: null,
        orderStartTime: null,
        orderEndTime: null,
        creationStartDate: null,
        creationEndDate: null,
        payStartTime: null,
        payEndTime: null,
        address: null,
      },
      auditType: '0',

      /** 待审核订单状态 */
      checkCodeList: [30211, 30221, 30411, 30421],
      title: '',
      dialogVisible: false,
      // 表单参数
      form: getDefaultForm(),
      // 表单校验
      rules: {
        name: [{ required: true, message: this.$t('SalesOrderToBeApproved.Please'), trigger: 'blur' }],
        typeCode: [{ required: true, message: this.$t('SalesOrderToBeApproved.select'), trigger: 'change' }],
      },
      labelsVersion: 12,
      labelList: [
        { label: this.$t('SalesOrderToBeApproved.form.Third'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: '190' },
        { label: this.$t('SalesOrderToBeApproved.form.Internal'), prop: 'innerOrderNo', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('SalesOrderToBeApproved.form.Label'), prop: 'tags', isCheck: true, disabled: false, width: '60' },
        { label: this.$t('SalesOrderToBeApproved.form.Approval'), prop: 'auditStatus', isCheck: true, disabled: false, width: '150' },
        { label: this.$t('SalesOrderToBeApproved.form.Sales'), prop: 'storeName', isCheck: true, disabled: false, width: '120' },
        { label: this.$t('SalesOrderToBeApproved.form.channel'), prop: 'channelTypeMeaning', isCheck: true, disabled: false, width: '135' },
        { label: this.$t('SalesOrderToBeApproved.form.Order'), prop: 'actionType', isCheck: true, disabled: false, width: '135' },
        { label: this.$t('SalesOrderToBeApproved.form.Product'), prop: 'goodsQuatity', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('SalesOrderToBeApproved.form.nickname'), prop: 'buyerNick', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('SalesOrderToBeApproved.form.comments'), prop: 'buyerRemarks', isCheck: true, disabled: false, width: '145' },
        { label: this.$t('SalesOrderToBeApproved.form.Merchant'), prop: 'orderRemarks', isCheck: true, disabled: false, width: '160' },
        { label: this.$t('SalesOrderToBeApproved.form.Consignee'), prop: 'receiverNameMask', isCheck: true, disabled: false, width: '125'},
        { label: this.$t('SalesOrderToBeApproved.form.mobile'), prop: 'receiverPhoneMask', isCheck: true, disabled: false, width: '135'},
        { label: this.$t('SalesOrderToBeApproved.form.address'), prop: 'addressMask', isCheck: true, disabled: false, width: '135' },
        { label: this.$t('SalesOrderToBeApproved.form.Status'), prop: 'deliveryStatus', isCheck: true, disabled: false, width: '120'},
        { label: this.$t('SalesOrderToBeApproved.form.Receiving'), prop: 'todo', isCheck: true, disabled: false, width: '115' },
        { label: this.$t('SalesOrderToBeApproved.form.Total'), prop: 'totalAmount', isCheck: true, disabled: false, width: '120' },
        { label: this.$t('SalesOrderToBeApproved.form.payable'), prop: 'buyerPay', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('SalesOrderToBeApproved.form.cost'), prop: 'costPrice', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('SalesOrderToBeApproved.form.Three'), prop: 'orderTime', isCheck: true, disabled: false, width: '170' },
        { label: this.$t('SalesOrderToBeApproved.form.Payment'), prop: 'payTime', isCheck: true, disabled: false, width: 130 },
        { label: this.$t('SalesOrderToBeApproved.form.document'), prop: 'creationDate', isCheck: true, disabled: false, width: '160'},
        { label: this.$t('SalesOrderToBeApproved.form.Estimated'), prop: 'predictDeliveryTime', isCheck: true, disabled: false, width: '140'},
        { label: this.$t('SalesOrderToBeApproved.form.Pre'), prop: 'preemptionStatus', isCheck: true, disabled: false, width: '180'},
        { label: this.$t('SalesOrderToBeApproved.form.Sourcing'), prop: 'sourceStatus', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('SalesOrderToBeApproved.form.Pending'), prop: 'suspendStatus', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('SalesOrderToBeApproved.form.occupied'), prop: 'syncPreempStatus', isCheck: true, disabled: false, width: '160'},
        { label: this.$t('SalesOrderToBeApproved.form.Shipment'), prop: 'syncDeliveryStatus', isCheck: true, disabled: false, width: '150'},
        { label: this.$t('SalesOrderToBeApproved.form.there'), prop: 'isGift', isCheck: true, disabled: false, width: '130' }, // (boolean, optional): 有无赠品 ,
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: '100' },
      ],

      goodsInfoTab: {
        title: this.$t('SalesOrderToBeApproved.form.information'),
        visible: false,
        orderId: null,
      },
    };
  },
  computed: {
    SCHL_CHANNEL_TYPE() {
      return this.$store.state.values.SCHL_CHANNEL_TYPE || [];
    },
    permissionBtns() {
      return this.$store.state.user.permissionBtns || [];
    },
    // 审核权限
    PERMISSION_RULES() {
      return ORDER_INTERNAL_ORDER_AUDIT_PERMISSION_RULES[this.auditType];
    },
    cptAuditPermission() {
      const INDEX = this.TOW_TABS[Number(this.auditType)].findIndex(
        e => e.value == this.queryParams.auditStatus.join(),
      );
      const THIS_RULES = this.PERMISSION_RULES[INDEX];
      return THIS_RULES.some(code => this.permissionBtns.includes(code.toLocaleLowerCase()));
    },
    // 批量选中行的权限
    cptSelectRowsPermissionIsRight() {
      return this.selectedRows.every(e => {
        const INDEX = Number(this.getAuditLvl(e.auditStatus));
        const THIS_RULES = this.PERMISSION_RULES[INDEX];
        return THIS_RULES.some(code => this.permissionBtns.includes(code.toLocaleLowerCase()));
      });
    },
  },
  watch: {
    queryParamsTime_order(v) {
      this.queryParams.orderStartTime = (v || [])[0];
      this.queryParams.orderEndTime = (v || [])[1];
    },
    queryParamsTime_create(v) {
      this.queryParams.creationStartDate = (v || [])[0];
      this.queryParams.creationEndDate = (v || [])[1];
    },
    queryParamsTime_pay(v) {
      this.queryParams.payStartTime = (v || [])[0];
      this.queryParams.payEndTime = (v || [])[1];
    },
    auditType: {
      handler(v, o) {
        // 找到变更前的状态码
        const INDEX = this.TOW_TABS[Number(o)].findIndex(
          e => e.value == this.queryParams.auditStatus.join(),
        );
        // 用新的状态码 更新 tab显示value ，更改搜索参数auditStatus、auditType
        this.auditTabsValue = this.TOW_TABS[Number(v)][INDEX].value;
        this.queryParams.auditStatus = this.auditTabsValue.split(',');
        this.queryParams.auditType = Number(v);

        // TODO:这里执行一次搜索
        this.reFresh();
      },
    },
  },
  mounted() {
    // TODO: 获取配置的审核名称作为 Tabs 名称
    // orderApi.getWaitAuditOrdersTabs().then(res => {
    //   this.auditTabs = res.nodeXList;
    // });
    this.$store.dispatch('values/getTags');
  },
  methods: {
    onHangUp(row){
      orderApi.unsuspendOrderByInner({
        innerOrderNo: row.innerOrderNo,
      }).then(()=>{
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        setTimeout(() => {
          this.reFresh();
        }, 500);
      })
    },
     // 订单找回
    async onOrderRetrieval() {
      // 二审自动刷新ES
      const res = await orderApi.autoSecondAuditOrderRefreshES();
      if (res.failed) this.$message.error(res.message);
      // 更新审核订单
      const res2 = await orderApi.updateAuditOrder(['30212']);
      if (!res2.failed) {
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        this.reFresh();
      }
    },
    getAuditLvl(auditStatus) {
      return auditStatus.slice(3, 4);
    },
    getMessageName(auditStatus) {
      // 取 审核状态码的第四位，1为一审，2为二审，以此类推
      const messagePre = this.auditType == 0 ? 'source-audit-received-' : 'send-audit-received-';
      return messagePre + this.getAuditLvl(auditStatus);
    },
    /** 查看商品信息 */
    onSkuDetail(row) {
      this.goodsInfoTab.orderId = row.id;
      this.goodsInfoTab.visible = true;
    },
    /** 审核 tabs 点击事件 */
    handleTabClick(tab, event) {
      this.queryParams.auditStatus = tab.name === 'all' ? null : tab.name.split(',');
      this.reFresh();
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime_order = null;
      this.queryParamsTime_create = null;
      this.queryParamsTime_pay = null;

      this.queryParams.isBuyerRemarks = null;
      this.queryParams.isOrderRemarks = null;

      this.queryParams.storeIdList = null;

      return new Promise(resolve => {
        resolve();
      });
    },
    /** 创建 */
    onAdd() {
      this.$refs.DataForm.show();
    },
    /** 审核 */
    onAudit() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('SalesOrderToBeApproved.form.Please'));
        return;
      }
      const checkStatus = this.selectedRows.every(e =>
        this.checkCodeList.includes(Number(e.auditStatus)),
      );
      if (!checkStatus) {
        this.$message.warning(this.$t('SalesOrderToBeApproved.form.have'));
        return;
      }
      // 权限判断
      if (!this.cptSelectRowsPermissionIsRight) {
        this.$message.warning(this.$t('SalesOrderToBeApproved.form.not'));
        return;
      }

      const text = `${this.$t('SalesOrderToBeApproved.form.Approved')} ${this.selectedRows.map(e => e.innerOrderNo).join(',')} ?`;
      this.$confirm(text, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          const auditList = this.selectedRows.map(e => {
            return {
              auditId: e.id,
              failReason: null,
              status: 1,
              messageId: this.getMessageName(e.auditStatus),
            };
          });
          this.orderAuditdeal(auditList);
        })
        .catch(() => {});
    },
    // 删除缓存
    deleteCache() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        return;
      }
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        let innerOrderNos = [];
        innerOrderNos = this.selectedRows.map(item => item.innerOrderNo);
        orderApi.deleteEsAudit(innerOrderNos).then(res => {
          if (!res.faild) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.$refs.BjPage.onResetQuery();
          }
        });
      }).catch(() => {});
    },
    onNoAudit() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        return;
      }
      const checkStatus = this.selectedRows.every(e =>
        this.checkCodeList.includes(Number(e.auditStatus)),
      );
      if (!checkStatus) {
        this.$message.warning(this.$t('SalesOrderToBeApproved.form.have'));
        return;
      }

      // 权限判断
      if (!this.cptSelectRowsPermissionIsRight) {
        this.$message.warning(this.$t('SalesOrderToBeApproved.form.not'));
        return;
      }

      const text = `${this.$t('SalesOrderToBeApproved.form.Reject')} ${this.selectedRows.map(e => e.innerOrderNo).join(',')} ?`;
      this.$confirm(text, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.$refs.failReason.show();
        })
        .catch(() => {});
    },
    getFailReason(msg) {
      const auditList = this.selectedRows.map(e => {
        return {
          auditId: e.id,
          failReason: msg,
          status: 2,
          messageId: this.getMessageName(e.auditStatus),
        };
      });
      this.orderAuditdeal(auditList);
    },
    orderAuditdeal(data) {
      orderApi.orderAuditdeal(data).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    /** 禁用 */
    onStatus(flag, row) {
      this.operationApi({
        flag: flag,
        id: row.id,
        objectVersionNumber: row.objectVersionNumber,
      });
    },

    /** 删除 */
    onDelete(row) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ id: row.id });
        })
        .catch(() => {});
    },
    operationApi(API_DATA) {
      settingApi.operationStockProcess(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    batchDeleteApi(API_DATA) {
      settingApi.deleteStockProcess(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}
::v-deep .bj-page .el-form-item__label {
  display: none;
}
</style>
